import React from 'react';
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { firebaseConfig,setupHelpers } from "./libs/firebase";
import { firebaseHelper } from 'ui';
import * as Sentry from "@sentry/react";
import { getAuth, connectAuthEmulator } from 'firebase/auth';
import { connectFirestoreEmulator } from 'firebase/firestore';


(window as any).MATTO_PROJECT='teams-admin'

firebaseHelper.initializeApp(firebaseConfig);
setupHelpers();
if (firebaseConfig.emulator) {
  console.log('Connecting to Firebase Emulator');
  connectAuthEmulator(getAuth(firebaseHelper.firebaseApp), 'http://localhost:9099', { disableWarnings: true });
  connectFirestoreEmulator(firebaseHelper.db, 'localhost', 8080);
} 



const useStaging = !  (window.location.hostname.includes('mattoboard.com')  || window.location.hostname.includes('web.app'))

Sentry.init({
  dsn: "https://5c18a30196a940c9ade7515923c03671@o1220868.ingest.sentry.io/6367335",
  tracesSampleRate: 0.01,
  autoSessionTracking: false,
  enabled: !useStaging,
  beforeSend(event, hint) {  return event; }
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
